import { Button, PageHeader } from '@berky/ui'
import { Link, useLocation } from 'react-router'

/** Angemeldet, aber ohne die nötige Rolle. */
export function ForbiddenPage() {
  const location = useLocation()
  const state = location.state as
    | { moduleId?: string; moduleTitle?: string }
    | null
  const moduleTitle = state?.moduleTitle

  // moduleId wird heute nicht angezeigt. Sie steht hier, weil diese Seite der
  // vorgesehene Ort für „Zugang beantragen" ist: Der Antrag richtet sich an eine
  // Rolle eines bestimmten Moduls, und die Route soll sich dafür nicht ändern.
  void state?.moduleId

  return (
    <div className="max-w-2xl">
      <PageHeader
        title="Keine Berechtigung"
        description={
          moduleTitle
            ? `Für die Anwendung „${moduleTitle}" ist Ihr Konto nicht freigeschaltet.`
            : 'Für diesen Bereich ist Ihr Konto nicht freigeschaltet.'
        }
      />
      <p className="text-sm text-muted-foreground">
        Wenden Sie sich an Ihre Führungskraft oder an die IT, wenn Sie Zugriff
        benötigen. Nennen Sie dabei den Namen der Anwendung.
      </p>
      <Button asChild className="mt-6">
        <Link to="/">Zur Startseite</Link>
      </Button>
    </div>
  )
}
